import { useRouter } from 'expo-router'
import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@/src/elements/button/default'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { storage } from '@/src/general/utilities/storage'
import { Cookie } from '@/src/general/utils/cookies/Cookie'
import { useRoutes } from '@/src/general/utils/routes'

export const DisconnectButton = () => {
  const {
    routes: { home },
  } = useRoutes()

  const { navigate } = useRouter()

  const handlePress = useCallback(() => {
    storage.clear()
    Cookie.clearAll()
    navigate(home())
  }, [home, navigate])

  return (
    <Button
      testID={TEST_ID.SETTINGS.ACCOUNT.DISCONNECT}
      startIcon={ICON.LEAVE}
      colors="primary"
      variant="faded"
      className="w-full sm:w-2/3"
      onPress={handlePress}
    >
      <FormattedMessage id="user.logout.word" />
    </Button>
  )
}
